import { render, staticRenderFns } from "./LocationPermission.vue?vue&type=template&id=64347ce0"
import script from "./LocationPermission.vue?vue&type=script&lang=js"
export * from "./LocationPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports